import React, { useState, useEffect } from 'react'
import {
  Avatar,
  Chip,
} from "@material-tailwind/react";
import parse from 'html-react-parser'
import { useShared } from '../../hooks/useShared';
import AMenu from '../../components/partials/AMenu';
import MainSection from '../../components/sections/MainSection';


const TABLE_HEAD = ["#", "عکس", "اسم", "تماس", "نقش‌ها", 'حالت', 'تاريخ ايحاد', 'اقدامات'];
const breadcrumbs = [{ name: 'کارمندان', link: null }];
const menuData = [
  {flag:"View",  name: 'جزئیات', icon: 'eye-outline', roles: [1,2,22] },
  {flag:"Edit", name: 'ويرايش', icon: 'create-outline', roles: [1,2,22] },
  {flag:"Delete", name: 'حذف', icon: 'trash-outline', roles: [1] },
]

const searchInputFields = [
  { label: 'اسم', name: 'name', type: 'text', roles: [1], icon: 'person', className: 'md:col-span-2' },
  { label: 'ايميل', name: 'email', type: 'text', roles: [1], icon: 'at-outline', className: 'md:col-span-2' },
  { label: 'شماره تماس', name: 'phone', type: 'text', roles: [1], icon: 'call-outline', className: 'md:col-span-2' },
  { label: 'نقش‌ها', name: 'roles', type: 'select', roles: [1], icon: 'text-outline', className: 'md:col-span-2', options: [], isMulti: false },
  { label: 'ايجاد کننده', name: 'creator_id', type: 'select', roles: [1], icon: 'text-outline', className: 'md:col-span-2', options: [] },
  { label: 'تاريخ ايجاد', name: 'created_at', type: 'pdate', roles: [1], icon: 'text-outline', className: 'md:col-span-2', },
];

const csvHeaders = [
  { label: "#", key: "index" },
  { label: "سمم", key: "full_name" },
  { label: "نام پدر", key: "father_name" },
  { label: "شماره تماس", key: "phone" },
  { label: "ايميل", key: "email" },
  { label: "نقش‌ها", key: "roles" },
  { label: "مقام", key: "position" },
  { label: "معاش", key: "salary" },
  { label: "اردس", key: "home_address" },
  { label: "تاريخ ايجاد", key: "date" },
  { label: "حالت", key: "status" },
  { label: "ايجاد کننده", key: "creator_id" },
];

const user_type = { value: 2, label: 'Employee' }


export default function Employees() {

  const { auth, com, navigate, consts, setModel,models,showDeleteDialog, setShowDeleteDialog } = useShared();

    useEffect(() => {
      if (!auth.hasRole([1, 2, 4, 22])) {
          return navigate("/db/notAllowed")
      }
  }, [])



  const handleMenu = (model, flag = false) => {
    console.log("handleMenu ", model, flag);

    if (flag === 'delete') {
      setModel(model)
      setShowDeleteDialog(!showDeleteDialog)

    }
    if (flag === 'edit') {
      setModel(model)
 
      navigate(`/db/users/new_user/${model.id}`, { state: { user_type } })
    }
    if (flag === 'view') {
      setModel(model)
      navigate(`/db/users/view_employee/${model.id}`, { state: { user_type } })
    }
  };


  const handleViewDialog = (obj) => {
    return [
      { l: 'First Name', v: obj?.first_name },
      { l: 'Last Name', v: obj?.last_name },
      { l: 'Phone', v: obj?.phones },
      { l: 'Email', v: obj?.email },
      { l: 'Roles', v: obj?.roles },
      { l: 'Companies', v: obj?.companies },
      { l: 'Description', v: obj?.description },
      { l: 'Added by', v: obj?.user?.full_name },
      { l: 'Status', v: obj?.status },
      { l: 'Last Update', v: com.ddmmyyhhmmA(obj?.updated_at) },
      { l: 'Photo', v: obj?.image_data ? consts.BASE_URL + obj?.image_data?.path : consts.DEFULAT_USER_PHOTO },
    ]
  }
  const getTableData = () => {
    return (
      <tbody className=''>
        {models?.data?.map((r, i) => {

          return (<tr key={r.id} >
            <td >{models?.from + i}</td>
            <td >
              <Avatar src={r?.image_data ? consts.BASE_URL + r.image_data?.path : consts.DEFULAT_USER_PHOTO} alt={r.first_name} className="h-8 w-8 md:h-12 md:w-12" />
            </td>
            <th >{r.full_name}</th>
            <td > <div className='flex flex-col'> <span>{r.phone}</span> <span>{r.email}</span>  </div>  </td>
            <td >{r?.user_roles && parse(r?.user_roles)}</td>
            <td> <Chip className='capitalize text-center' variant="ghost" size="sm" color={r.status === 1 ? 'green' : 'red'} value={r.status === 1 || r.status ? 'Enable' : 'Disable'} /> </td>
            <td >{com.dateConvert(r?.created_at, false, true)}
              <p>{r?.user?.full_name}</p>
            </td>
            <td >
              <AMenu v={{ handleMenu: (row, flag) => handleMenu(row, flag), row: r, menuData }} />
            </td>
          </tr>)
        })
        }
      </tbody>
    )
  }

  return (

    <div>
      <MainSection v={{
        handleViewDialog,
        searchInputFields,
        newModelInputFields: [{ test: "new page" }],
        TABLE_HEAD,
        breadcrumbs,
        tableData: getTableData(),
        addNewItemTitle: "کارمند جديد",
        tableTitle: 'لست کارمندان',
        url: "employees",
        mUrl: { delete: 'users', create: 'employees', getAll: 'userAdvanceSearch' },
        searchData: { user_type },
        csv: { csvHeaders, show: true }
      }} />
    </div>)

}
